export enum Validations {
  Echec = 'echec',
  Requis = 'requis',
  Courriel = 'email',
  Numerique = 'numerique',
  MaximumCaracteres = 'max',
  MinimumValeur = 'min_value',
  Parmis = 'oneOf',
}
